export const SIZES = {
  sm: "sm",
  default: "default",
  lg: "lg",
};
